import { useEffect, useState } from "react";
import { MainPageComponent } from "../dashboard";
import { PageHeader } from "../../components/partials/header";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Buffer } from "buffer";
import { apiCall } from "../../data/useFetcher";

const Tool = () => {
	const [tab, setTab] = useState("overview"),
		[currentTool, setCurrentTool] = useState(null),
		[getSearch] = useSearchParams(),
		toolExtract = getSearch?.get("t"),
		navigate = useNavigate();

	useEffect(() => {
		if (!toolExtract) return navigate("/");

		// let decoding = atob(toolExtract);
		const decoded = Buffer.from(toolExtract, "base64").toString();

		const getTool = async () => {
			let { response, errArr, errMsg } = await apiCall({
				type: "get",
				url: `/api/v1/tools/retrieve-tool?tool=${decoded}`,
				noToast: true,
			});
			// console.log({ response, errArr, errMsg });
			if (errArr) {
				return navigate("/");
			}
			if (errMsg) {
				return navigate("/");
			}
			if (response) {
				let dd = response?.data?.data || response?.data || response;
				setCurrentTool(dd);
			}
		};
		getTool();
	}, [toolExtract, navigate]);

	useEffect(() => {
		if (currentTool)
			document.title = `Tools Map Dashboard: ${currentTool?.toolName}`;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentTool]);

	return (
		<>
			<PageHeader />
			<MainPageComponent
				currentTool={currentTool}
				setModal={() => {}}
				start={true}
				mapAble={false}
				tab={tab}
				setTab={setTab}
			/>
		</>
	);
};

export default Tool;
